import { styled } from '@mui/material/styles';

export const Text = styled('p')(({ theme }) => ({
  color: theme.color.primary.main,
  a: {
    color: theme.color.primary.main
  }
}));

export const ButtonContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'end'
}));
